let pos_settings_Discount = require("../../templates/pos/settings/Discount.handlebars");
let MenuItemOptions = require("../../templates/settings/MenuItemOptions.handlebars");
let $ = require("jquery");
let _ = require("underscore");
let Backbone = require("backbone");
import POS from "../../POS.js";
import ValidationView from "../comp/ValidationView.js";
import i18n from "../../utils/i18n";
import ModalView from "../comp/ModalView.js";
import React from 'react';
import ReactDOM from 'react-dom';
import MenuItemSelector from '../../react/common/MenuItemSelector';

let main = function () {
    return Backbone.View.extend({
        events: {
            'click .create': 'showModal',
            'click .modal .ok': 'createDiscount',
            'click .modal .delete': 'deleteDiscount',
            'click .discount': 'showEditModal',
            'click .typeGroup input': 'typeSelect',
            "click .tab-container li": "switchTab",
            "change select.category-selector": "selectCategory",
            "click .btn.add-usage": "addUsage",
            "click .btn.exclude-usage": "excludeUsage",
//                "click .discount-usage .items .item": "removeUsageItem",
            "click .scope-choose": "chooseScope",
            "click .btn-cancel.scope-editing-btn": "hideScope",
            "click .discount-usage .item": "removeDiscountUsageItem",
            'click .radio-btn': '_clickRadio',
            'click .check-box input:checkbox': '_clickCheckbox'
        },

        render: function () {
            return this;
        },
        _clickRadio: function (event) {
            var _this = $(event.currentTarget),
                block = _this.closest(".form-group");
            block.find('input:radio').prop('checked', false);
            block.find(".radio-btn").removeClass('checkedRadio');
            _this.addClass('checkedRadio');
            _this.find('input:radio').prop('checked', true);
            this.typeSelect(event);
        },

        _clickCheckbox: function (event) {
            var _this = $(event.currentTarget),
                checkboxDiv = _this.closest('.check-box');
            _this.prop('checked', !_this.prop('checked'));
            checkboxDiv.toggleClass('checkedBox');
        },
        switchTab: function (event) {
            var li = $(event.currentTarget), container = li.closest(".tab-container");
            li.addClass('active').siblings('li').removeClass('active');
            container.find(".tab-pane").removeClass("active");
            container.find(".tab-pane." + li.data("target")).addClass("active");
        },
        selectCategory: function (evt) {
            var self = this, options, optionsClone,
                categorySelector = self.$(".category-selector"),
                menuItemSelector = self.$(".menu-item-selector");
            options = MenuItemOptions({
                items: categorySelector.val() == "0" ? null : POS.getMenu().getCategories().get(parseInt(categorySelector.val())).get("menuItems").toJSON()
            });
            optionsClone = $(options).clone();
            _.each(self.$(".discount-items .item"), function (usage) {
                _.each($(optionsClone).find("option"), function (option) {
                    if ($(option).val() == $(usage).data("itemid").toString()) {
                        console.log("val = ", $(option).val());
                        console.log("val = ", $(usage).data("itemid").toString());
                        $(option).remove();
                    }
                });
                if (categorySelector.val() == 0) {
                    $(usage).show();
                } else if ($(usage).data("cateid") != categorySelector.val()) {
                    $(usage).hide();
                } else {
                    $(usage).show();
                }
            });
            self.$(".tag-title").text(categorySelector.val() == 0 ? "全部餐品" : $(evt.currentTarget).find("option:selected").text());
            menuItemSelector.html(optionsClone.html());
        },

        addUsage: function () {
            var self = this, option,
                categorySelector = self.$(".category-selector"),
                menuItemSelector = self.$(".menu-item-selector");
            if (parseInt(menuItemSelector.val()) !== 0) {
                option = menuItemSelector.find("option:selected");
                self.appendUsageItem("menu-item", option);
                option.addClass("selected");
            } else if (parseInt(categorySelector.val()) !== 0) {
                option = categorySelector.find("option:selected");
                self.appendUsageItem("category", option);
                option.addClass("selected");
            }
        },

        excludeUsage: function () {
            var self = this, option,
                categorySelector = self.$(".category-selector"),
                menuItemSelector = self.$(".menu-item-selector");
            if (parseInt(menuItemSelector.val()) !== 0) {
                option = menuItemSelector.find("option:selected");
                self.appendUsageItem("menu-item", option);
                option.addClass("selected");
            } else if (parseInt(categorySelector.val()) !== 0) {
                option = categorySelector.find("option:selected");
                self.appendUsageItem("category", option);
                option.addClass("selected");
            }
        },

        appendUsageItem: function (type, option) {
            var options = (type == "category") ? this.$(".menu-item-selector option:not(.selected)") : option;
            var added = [];
            $.each(options, function (index, val) {
                var id = $(val).val(), selector = ("discountUsageItem-" + id);
                if ($("#" + selector).size() > 0) {
                    if ($("#" + selector).hasClass("removed")) {
                        $("#" + selector).removeClass("removed");
                    } else {
                        added.push($(val).text());
                    }
                } else if (id > 0 && $("#" + selector).size() == 0) {
                    var item = $("<div id='" + selector + "' class='item'>" + $(val).text() + "<span class='delete-item'>x</span> </div> ");
                    item.data("id", id);
                }
                $(".discount-items").append(item);
            });
            if (added.length > 0) {
                var modalModel = new Backbone.Model();
                var modalView = new ModalView({model: modalModel});
                modalView.body("<div style='text-align: center; padding: 10px'>" + i18n.msg("pos.discount.usage.duplicate", added.join(", ")) + "</div>");
                modalView.$el.find('.modal-content').addClass('settingsModal');
                modalView.$el.find('.btn-confirm').addClass('saveCreate-btn');
                modalView.confirmButtonName(i18n.msg("pos.confirm"));
                modalView.render();
                modalModel.once("change", function () {
                    modalView.close();
                });
            }
        },

        buildUsageItem: function (className, option) {
            return "<span class='" + className + "' data-id='" + option.val + "'>" + option.text + "</span>"
        },

        /*removeUsageItem: function (evt) {
         var item = $(evt.currentTarget);
         if (item.is(".newly")) {
         item.slideUp(function () {
         item.remove();
         });
         } else {
         item.addClass("hidden").addClass("removed");
         }
         },*/

        createDiscount: function (evt) {
            var button = $(evt.currentTarget);
            // if (this.$('.modal').hasClass('scope-editing')) {
            //     this.$(".modal").removeClass("scope-editing");
            //     if (this.$(".discount-usage .worked-items .item").not(".removed").length === 0) {
            //         this.$(".discount-scope-radios input[type='radio']")[0].click();
            //     }
            //     return;
            // }

            button.attr("disabled", true);

            this.$('.has-error').removeClass('has-error');
            this.$('.help-block').text('');

            var validation = new ValidationView({el: this.$('#discountNameInput')});

            if (!validation.notEmpty().isValid()) {
                validation.render();
                button.removeAttr("disabled");
                return;
            }

            var id = this.$('.modal').data('data-id'), usages = {worked: {items: []}, removed: {items: []}},
                url = id ? '/api/discount/edit/' + id : '/api/discount/create',
                params = {
                    name: this.$('#discountNameInput').val(),
                    type: this.$('[name="typeOptions"]:checked').val(),
                    value: parseFloat(this.$('#discountValueInput').val()),
                    enabled: this.$('[name="statusOptions"]:checked').val(),
                    singe: this.$('[name=singeOptions]:checked').val(),
                    needApproval: this.$('[name=approvalOptions]:checked').val()
                }, self = this;


            // usages.worked.items = new Array();
            // _.each(self.$(".discount-usage .worked-items .item"), function (item) {
            //     item = $(item);
            //     if (item.is(".removed")) {
            //         usages.removed.items = usages.removed.items || [];
            //         usages.removed.items.push(item.data("id"));
            //     } else {
            //         usages.worked.items.push(item.data("id"));
            //     }
            // });
            // usages = this.$('[name="scopeOptions"]:checked').val() == "true" ? null : JSON.stringify(usages);
            // params.usagesJson = usages;
            const categoryUsageMap = this.$('#categoryUsageMap').val();
            if(categoryUsageMap) {
                params.usagesJson = categoryUsageMap;
            }
            console.log("params:", params);

            if (params.name.length > 15) {
                this.$('.nameGroup').addClass('has-error').find('.help-block').text(i18n.msg("pos.settings.discount.nameError"));
                button.removeAttr("disabled");
                return;
            }

            if (params.type == "Percentage" && (isNaN(params.value) || !(params.value <= 100 && params.value >= 0))) {
                this.$('.dValue').addClass('has-error').find('.help-block').text(i18n.msg('pos.settings.discount.percentError'));
                button.removeAttr("disabled");
                return;
            }

            if (params.type == "Amount" && (isNaN(params.value) || params.value < 0)) {
                this.$('.dValue').addClass('has-error').find('.help-block').text(i18n.msg('pos.settings.discount.valueError'));
                button.removeAttr("disabled");
                return;
            }

            var result = $.post(url, params);
            POS.showLoading(true);
            result.done(function (res) {
                if (res.success) {
                    if (self.$('.discountList .discount').length == 0) {
                        self.$('.discountList').empty();
                    }
                    params.id = res.id;
                    params.percentage = params.type == "Percentage";
                    params.disabled = !(params.enabled === 'true');
                    params.currency = POS.getRestaurant().get('currencySymbol');
                    var discountView = $(pos_settings_Discount(params));
                    self.$('.discountList .discount[data-id="' + res.id + '"]').remove();
                    self.$('.discountList').prepend(discountView);
                    self.closeModal();
                    self.trigger('needRefresh');
                    self._checkDiscounts();
                } else {
                    self.$('.modal .errorMsg').addClass("has-error").find(" .help-block").text(res.error)
                }
            });

            result.fail(function (res) {
                self.$('.modal .errorMsg').addClass("has-error").find(" .help-block").text(res);
            });

            result.always(function () {
                button.removeAttr("disabled");
                POS.showLoading(false);
            });
        },

        _checkDiscounts: function () {
            var self = this;
            if (self.$('.discountList .discount').length == 0) {
                self.$('.discountFirsttime').removeClass("hidden");
                self.$('.has-discount').addClass("hidden");
            } else {
                self.$('.discountFirsttime').addClass("hidden");
                self.$('.has-discount').removeClass("hidden");
            }
        },

        deleteDiscount: function () {
            var id = this.$('.modal').data('data-id'), name = this.$('.modal').data('data-name'), self = this;

            var _deleteDiscount = function () {
                var result = $.post('/api/discount/delete/' + id);
                POS.showLoading(true);
                result.success(function (res) {
                    if (res.success) {
                        self.$('.discount[data-id="' + id + '"]').remove();
                        self.closeModal();
                        self.trigger('needRefresh');
                        self._checkDiscounts();
                    } else {
                        self.$('.modal .help-block').text(res.error)
                    }
                });

                result.error(function (res) {
                    self.$('.modal .help-block').text(res);
                });
                result.always(function (response) {
                    POS.showLoading(false);
                });
            };

            var modalModel = new Backbone.Model();
            var modalView = new ModalView({model: modalModel});
            console.log("name:", name);
            modalView.body("<div style='text-align: center; line-height: 240px;'>" + i18n.msg("pos.discount.delete.confirm", name.toString()) + "</div>");
            modalView.$el.find('.modal-content').addClass('settingsModal');
            modalView.$el.find('.btn-confirm').addClass('saveCreate-btn');
            modalView.confirmButtonName(i18n.msg("pos.confirm"));
            modalView.render();
            modalModel.once("change", function () {
                if (modalModel.get("shouldConfirm")) {
                    _deleteDiscount();
                }
                modalView.close();
            });
        },

        showModal: function () {
            var modal = this.$('.modal');
            var categorySelector = this.$(".category-selector");
            categorySelector.val(0);
            categorySelector.trigger("change");
            modal.find('.item-search').val("");
            modal.find('.search-panel').hide();
            modal.find('.modal-content').addClass("settingsModal");
            modal.find('.has-error').removeClass('has-error');
            modal.find('.help-block').text('');
            modal.find('.edit').addClass('hidden');
            modal.find('.create').removeClass('hidden');
            if (modal.find('.ok').hasClass("saveEdit-btn")) {
                modal.find('.ok').removeClass('saveEdit-btn');
            }
            if (!modal.find('.ok').hasClass("saveCreate-btn")) {
                modal.find('.ok').addClass('saveCreate-btn');
            }
            this.$('#discountNameInput, #discountValueInput').val('');
            this.$('.percent').prop('checked', true);
            this.$('.amount').prop('checked', false);
            this.$('.d_enabled').prop('checked', true);
            this.$('.d_disabled').prop('checked', false);
            this.$('.modal').find('.delete').addClass('hidden');
            this.$('.modal').data('data-id', null).modal('show');
            this.$(".discount-usage .discount-items").empty();
        },

        chooseScope: function () {
            //console.log("chooseScope");
            //this.$(".modal").addClass("scope-editing");
            const categoryString = this.$('#categoryUsageMap').val();
            const categoryMap = categoryString ? JSON.parse(categoryString) : {};
            const root = $('<div></div>');
            const self = this;
            $('body').append(root);
            ReactDOM.render(
                <MenuItemSelector
                    categoryMap={categoryMap}
                    onClose={(categories) => {
                        console.log('categories selected ', categories);
                        ReactDOM.unmountComponentAtNode(root.get(0));
                        root.remove();
                        self.$('#categoryUsageMap').remove();
                        const categoryUsage = $('<input id="categoryUsageMap" type="hidden"/>');
                        categoryUsage.val(JSON.stringify(categories));
                        self.$el.append(categoryUsage);
                    }}
                    />, root.get(0));
        },

        hideScope: function (evt) {
            console.log("hideScope");
            evt.stopPropagation();
            this.$(".modal").removeClass("scope-editing");
            if (this.$(".discount-usage .worked-items .item").not(".removed").length === 0) {
                this.$(".discount-scope-radios input[type='radio']")[0].click();
            }
        },

        removeDiscountUsageItem: function (evt) {
            $(evt.currentTarget).closest(".item").addClass("removed");
        },
        _searchItem: function () {
            var inputText = this.$(".item-search").val(), self = this,
                categorySelector = this.$(".category-selector");
            var exist = false;
            _.each(this.$(".discount-items .item"), function (usage) {
                var shortCode = $(usage).data("shortcode");
                var menuItem = $(usage).data("name");
                if (shortCode == inputText || inputText == menuItem) {
                    $(usage).show();
                    categorySelector.val($(usage).data("cateid"));
                    categorySelector.trigger("change");
                    exist = true;
                } else {
                    $(usage).hide();
                }
            });
            if (exist) {
                this.$(".tag-title").text("查找餐品");
            } else {
                _.each(POS.getMenu().getCategories().toJSON(), function (cate) {
                    var nameItem = cate.menuItems.findWhere({name: inputText});
                    var shortCodeItem = cate.menuItems.findWhere({shortCode: inputText});
                    if (nameItem) {
                        exist = true;
                        categorySelector.val(nameItem.get("categoryId"));
                        categorySelector.trigger("change");
                        self.$(".tag-title").text(nameItem.get("category").name);
                    }
                    if (shortCodeItem) {
                        exist = true;
                        categorySelector.val(shortCodeItem.get("categoryId"));
                        categorySelector.trigger("change");
                        self.$(".tag-title").text(shortCodeItem.get("category").name);
                    }
                });
            }
            if(!exist){
                self.$(".tag-title").text("未找到任何餐品");
            }
        },

        showEditModal: function (evt) {
            var self = this, modal = this.$('.modal'), jxhr, className, option;
            var categorySelector = self.$(".category-selector");
            categorySelector.val(0);
            categorySelector.trigger("change");
            modal.find('.item-search').val("");
            modal.find('.search-panel').show();
            modal.find('.has-error').removeClass('has-error');
            modal.find('.help-block').text('');
            modal.find('.delete, .edit').removeClass('hidden');
            modal.find('.create').addClass('hidden');

            if (modal.find('.ok').hasClass("saveCreate-btn")) {
                modal.find('.ok').removeClass('saveCreate-btn');
            }
            if (!modal.find('.ok').hasClass("saveEdit-btn")) {
                modal.find('.ok').addClass('saveEdit-btn');
            }
            var ele = $(evt.currentTarget), id = ele.data('id'), name = ele.data('name');
            this.$('#discountNameInput').val(ele.data('name'));
            this.$('#discountValueInput').val(ele.data('value'));
            this.$(ele.data('type') == 'Percentage' ? '.percent' : '.amount').prop('checked', true);
            this.$('.d_disabled').prop('checked', ele.data('disabled'));
            this.$('.d_enabled').prop('checked', !ele.data('disabled'));
            this.$('.singe-order').prop('checked', ele.data('singe'));
            this.$('.singe-cashier').prop('checked', !ele.data('singe'));
            if (ele.data('type') == 'Percentage') {
                this.$('.percent').closest('.radio-btn').addClass('checkedRadio');
                this.$('.amount').closest('.radio-btn').removeClass('checkedRadio');
            } else {
                this.$('.percent').closest('.radio-btn').removeClass('checkedRadio');
                this.$('.amount').closest('.radio-btn').addClass('checkedRadio');
            }
            if (ele.data('disabled')) {
                this.$('.d_disabled').closest('.radio-btn').addClass('checkedRadio');
                this.$('.d_enabled').closest('.radio-btn').removeClass('checkedRadio');
            } else {
                this.$('.d_disabled').closest('.radio-btn').removeClass('checkedRadio');
                this.$('.d_enabled').closest('.radio-btn').addClass('checkedRadio');
            }
            if (ele.data('singe')) {
                this.$('.singe-order').closest('.radio-btn').addClass('checkedRadio');
                this.$('.singe-cashier').closest('.radio-btn').removeClass('checkedRadio');
            } else {
                this.$('.singe-order').closest('.radio-btn').removeClass('checkedRadio');
                this.$('.singe-cashier').closest('.radio-btn').addClass('checkedRadio');
            }

            if (ele.data('approval')) {
                this.$('.a_enabled').closest('.radio-btn').addClass('checkedRadio');
                this.$('.a_disabled').closest('.radio-btn').removeClass('checkedRadio');
            } else {
                this.$('.a_enabled').closest('.radio-btn').removeClass('checkedRadio');
                this.$('.a_disabled').closest('.radio-btn').addClass('checkedRadio');
            }

            this.$(".discount-usage .discount-items").empty();
            jxhr = $.post("/api/discount/usages", {id: id});
            this.$('#categoryUsageMap').remove();
            POS.showLoading(true);
            jxhr.done(function (response) {
                console.log(response);
                if (response.usages.length > 0) {
                    const categoryUsage = $('<input id="categoryUsageMap" type="hidden"/>');
                    const categoryMap = {};
                    response.usages.forEach(usage => {
                        if(usage.category) {
                            categoryMap[usage.category.id] = usage.category;
                            categoryMap[usage.category.id].allItems = true;
                        } else if(usage.item) {
                            let cat = categoryMap[usage.item.cateId];

                            if(!cat) {
                                cat = {id: usage.item.cateId, items: [{id: usage.item.id, name: usage.item.name}], allItems: false};
                                categoryMap[usage.item.cateId] = cat;
                            } else {
                                cat.items = cat.items.concat({id: usage.item.id, name: usage.item.name});
                            }
                        }
                    });
                    categoryUsage.val(JSON.stringify(categoryMap));
                    self.$el.append(categoryUsage);

                    // _.each(response.usages, function (usage) {
                    //     if (usage.item) {
                    //         className = "item text-primary menu-item";
                    //         var item = $("<div id='" + "discountUsageItem-" + usage.item.id + "' class='item'  data-name= '" + usage.item.name + "' data-itemid= '" + usage.item.id + "' data-cateid='" + usage.item.cateId + "' data-shortcode='" + usage.item.shortcode + "'>" + usage.item.name + "<span class='delete-item'>x</span> </div> ");
                    //         item.data("id", usage.item.id);
                    //         self.$(".discount-items").append(item);
                    //     }
                    // });
                    self.$('.scope-all').closest('.radio-btn').removeClass('checkedRadio');
                    self.$('.scope-part').closest('.radio-btn').addClass('checkedRadio');
                    modal.find('.discount-scope-radios input.scope-all').prop('checked', false);
                    modal.find('.discount-scope-radios input.scope-part').prop('checked', true);
                } else {
                    self.$('.scope-all').closest('.radio-btn').addClass('checkedRadio');
                    self.$('.scope-part').closest('.radio-btn').removeClass('checkedRadio');
                    modal.find('.discount-scope-radios input.scope-all').prop('checked', true);
                    modal.find('.discount-scope-radios input.scope-part').prop('checked', false);
                }
            });
            jxhr.fail(function (response) {
                self.$('.modal .help-block').text(response);
            });
            jxhr.always(function (response) {
                self.$('.modal').data('data-id', id).data('data-name', name).modal('show');
                POS.showLoading(false);
            });
        },

        closeModal: function () {
            this.$('.modal').modal('hide');
        },

        typeSelect: function (evt) {
            var labelCode = 'pos.settings.discount.' + ($(evt.currentTarget).hasClass('amount') ? 'value' : 'percent'),
                msg = i18n.msg('pos.settings.discount.' +
                    ($(evt.currentTarget).hasClass('amount') ? 'valueInputHint' : 'percentInputHint'));
            this.$('.dValue label').text(i18n.msg(labelCode));
            this.$('#discountValueInput').attr('placeholder', msg);
        }

    });
};

export default main();


// WEBPACK FOOTER //
// ./src/view/settings/DiscountSettingView.js